import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaTag, FaRegFileAlt } from 'react-icons/fa';

function CardItemModel(props) {
  return (
    <>
      <li className='cards__item'>
        <Link className='cards__item__link' to={props.path}>
          <figure className='cards__item__pic-wrap' data-category={props.label}>
            <img
              className='cards__item__img'
              alt='Travel Image'
              src={props.src}
            />
          </figure>
          <div className='cards__item__info'>
            <h5 className='cards__item__text'>{props.text}</h5>
            <div className='cards__item__price'>
              <FaTag className='design'/> {props.price}
            </div>
            <div className='cards__item__description'><FaRegFileAlt className='details design'/>   {props.description}</div>
          </div>
        </Link>
      </li>
    </>
  );
}

export default CardItemModel;
